export class ContactCounselorFormModel {
  student_email: string;
  first_name: string;
  last_name: string;
  text: string;

  constructor() {
    this.reset();
  }

  reset() {
    this.student_email = '';
    this.first_name = '';
    this.last_name = '';
    this.text = '';
  }
}

angular.module('capability-ng-global').service('contactCounselorFormModel', ContactCounselorFormModel);



// WEBPACK FOOTER //
// ./app/lib/global/modals/contact_counselor/contact_counselor_form_model.ts